module.exports = __webpack_public_path__ + "1.5.0-unryo/img/snmp.808d2252.svg";